import React from 'react';
import { ParagraphSkeletonContainer, Skeleton } from './styled';
import { SkeletonProps } from './types';

export const ParagraphSkeleton: React.FC<SkeletonProps & { parts?: number }> = ({
  width = '100%',
  height = '1.5rem',
  parts = 1,
  ...props
}) => (
  <ParagraphSkeletonContainer>
    {Array.from({ length: parts }, (_, index) => (
      <Skeleton key={index} height={height} width={width} {...props} />
    ))}
  </ParagraphSkeletonContainer>
);
